import { LanguagesAbbr } from '@/types/translation.types';

const isRtlLanguage = (language: LanguagesAbbr | string): boolean => {
  const forceRtlLanguages: (LanguagesAbbr | string)[] = ['ar', 'he', 'fa', 'ps', 'sd', 'ur', 'ku'];
  return forceRtlLanguages.includes(language);
};

export default isRtlLanguage;
